import React from 'react';

export default function TertiaryButton({ onClick, disabled, icon, label, type = 'button', style }) {
	return <button style={style} disabled={disabled || false} type={type} className="btn btn-tertiary" onClick={onClick || (() => {})}>
		{icon && <span className={'fa fa-' + icon} />}
		{label && <span>{label}</span>}
	</button>;
}
